import { render, staticRenderFns } from "./ShippingRatesDropdown.vue?vue&type=template&id=8620fa94"
import script from "./ShippingRatesDropdown.vue?vue&type=script&lang=js"
export * from "./ShippingRatesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8620fa94')) {
      api.createRecord('8620fa94', component.options)
    } else {
      api.reload('8620fa94', component.options)
    }
    module.hot.accept("./ShippingRatesDropdown.vue?vue&type=template&id=8620fa94", function () {
      api.rerender('8620fa94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShippingRatesDropdown.vue"
export default component.exports